// import { GetAllOrdersByCustomerAction } from "../Slices/Customer/GetAllOrdersByCustomer";
import { clearCartAction } from "../Slices/AddToCard/clearCart";
import { decrementQuantityAction } from "../Slices/AddToCard/decrementQuantity";
import { getCartItemCountAction } from "../Slices/AddToCard/getCartItemCount";
import { getCartItemsAction } from "../Slices/AddToCard/getCartItems";
import { getPlanByIdAction } from "../Slices/AddToCard/getPlanById";
import { incrementQuantityAction } from "../Slices/AddToCard/incrementQuantity";
import { addMultiPurchaseAction } from "../Slices/Customer/addMultiPurchase";
import { customerLoginAction } from "../Slices/Customer/customerLogin";
import { customerRegisterAction } from "../Slices/Customer/customerRegister";
import { getCustomerGoldBalanceDashboardAction } from "../Slices/Customer/getCustomerGoldBalanceDashboard";
import { getCustomerRewardsListAction } from "../Slices/Customer/getCustomerRewardsList";
import { getKYCByCountryAction } from "../Slices/Customer/getKYCByCountry";
import { getPurchasesByCustomerIdAction } from "../Slices/Customer/getPurchasesByCustomerId";
import { getReferralRewardDashboardAction } from "../Slices/Customer/getReferralRewardDashboard";
import { ImageUploadPostAction } from "../Slices/Customer/ImageUploadPost";
import { getAllActivePlansAction } from "../Slices/Operator/getAllActivePlans";
import { getCustomersByCreatorAction } from "../Slices/Operator/getCustomersByCreator";
import { getOperatorDashboardMetricsAction } from "../Slices/Operator/getOperatorDashboardMetrics";
import { loginOperatorAction } from "../Slices/Operator/loginOperator";
import { managementRegisterForCustomerAction } from "../Slices/Operator/managementRegisterForCustomer";
import { PurchaseSchemesAction } from "../Slices/Schemes/PurchaseSchemes";
import { EmailSendOtpAction } from "../Slices/VerificationOtp/EmailSendOtp";
import { EmailVerifyOtpAction } from "../Slices/VerificationOtp/EmailVerifyOtp";
import { resetPasswordForCustomerAction } from "../Slices/VerificationOtp/resetPasswordForCustomer";
import { getAllAboutUsSectionsAction } from "../Slices/website/AboutUs/getAllAboutUsSections";
import { getAllBlogSectionsAction } from "../Slices/website/blog/getAllBlogSections";
import { getAllContactUsSectionsAction } from "../Slices/website/contactUs/getAllContactUsSections";
import { postContactUsFormAction } from "../Slices/website/contactUs/postContactUsForm";
import { getAllHomeSectionsAction } from "../Slices/website/home/getAllHomeSections";
import { getAllReferralsSectionsAction } from "../Slices/website/referrals/getAllReferralsSections";
import { getAllstakeNowSectionsAction } from "../Slices/website/stakeNow/getAllstakeNowSections";
import { uploadPdfAndImageAction } from "../Slices/Customer/uploadPdfAndImage";
import { getPurchasesByCreatorAction } from "../Slices/Operator/getPurchasesByCreator";
import { getCashPurchasesByCreatorAction } from "../Slices/Operator/getCashPurchasesByCreator";
import { getAllCustomersStatusAction } from "../Slices/AuthUser/getAllCustomersStatus";
import { getCustomerByIdAction } from "../Slices/AuthUser/getCustomerById";
import { approveCustomerAction } from "../Slices/AuthUser/approveCustomer";
import { checkCustomerExistForEmailRegisterAction } from "../Slices/Customer/checkCustomerExistForEmailRegister";
import { checkCustomerExistPhoneForRegisterAction } from "../Slices/Customer/checkCustomerExistPhoneForRegister";
import { getAllUserWithRoleAction } from "../Slices/AuthUser/getAllUserWithRole";
import { multiUserCreationAction } from "../Slices/AuthUser/multiUserCreation";
import { getNetBankingPurchasesByCreatorAction } from "../Slices/Operator/getNetBankingPurchasesByCreator";
import { addPlanPostAction } from "../Slices/Schemes/addPlanPost";
import { getAllPlansGetAction } from "../Slices/Schemes/getAllPlansGet";
import { getAllFinanceConsultantListForAuthUserAction } from "../Slices/Operator/getAllFinanceConsultantListForAuthUser";
import { getAllCustomerRewardsListForAuthUserAction } from "../Slices/Operator/getAllCustomerRewardsListForAuthUser";
import { getAllPurchasesListForAuthUserAction } from "../Slices/Operator/getAllPurchasesListForAuthUser";
import { getAllTiersAction } from "../Slices/Tiers/getAllTiers";
import { createTierAction } from "../Slices/Tiers/createTier";
import { getAllRolesWithModulesAction } from "../Slices/userRole/getAllRolesWithModules";
import { createRoleWithPermissionsAction } from "../Slices/userRole/createRoleWithPermissions";
import { getAllRolesAction } from "../Slices/userRole/getAllRoles";
import { getPurchaseByIdAction } from "../Slices/Operator/getPurchaseById";
import { updatePlanPutAction } from "../Slices/Schemes/updatePlanPut";
import { getPermissionsForAuthUserAction } from "../Slices/userRole/getPermissionsForAuthUser";
import { updateAllPermissionsForAuthUserAction } from "../Slices/userRole/updateAllPermissionsForAuthUser";
import { getReferrerCustomerRewardsByCustomerIdAction } from "../Slices/Operator/getReferrerCustomerRewardsByCustomerId";
import { activateLastTierAction } from "../Slices/Tiers/activateLastTier";
import { inactivateLastTierAction } from "../Slices/Tiers/inactivateLastTier";
import { getAuthUserByIdAction } from "../Slices/AuthUser/getAuthUserById";
import { updateAuthUserAction } from "../Slices/AuthUser/updateAuthUser";
import { softDeleteAuthUserAction } from "../Slices/AuthUser/softDeleteAuthUser";

import { updateTierAction } from "../Slices/Tiers/updateTier";
import { getTierByIdAction } from "../Slices/Tiers/getTierById";
import { deletePlanAction } from "../Slices/Schemes/deletePlan";
import { addHomeSectionPostAction } from "../Slices/ContentManagement/HomeSection/addHomeSectionPost";
import { addStakeNowSectionPostAction } from "../Slices/ContentManagement/StakeNowSection/addStakeNowSection";
import { getStakeNowSectionByIdAction } from "../Slices/ContentManagement/StakeNowSection/getStakeNowSectionById";
import { updateStakeNowSectionAction } from "../Slices/ContentManagement/StakeNowSection/updateStakeNowSection";
import { getAllCitiesByStateAction } from "../Slices/Customer/getAllCitiesByState";
import { getAllStatesByCountryAction } from "../Slices/Customer/getAllStatesByCountry";
import { getAllCountryNamesAction } from "../Slices/Customer/getAllCountryNames";
import { deleteStakeNowSectionAction } from "../Slices/ContentManagement/StakeNowSection/deleteStakeNowSection";
import { AddCountryPostAction } from "../Slices/Country/AddCountryPost";
import { AddStatePostAction } from "../Slices/Country/AddStatePost";
import { AddCityPostAction } from "../Slices/Country/AddCityPost";
import { getCountryByIdAction } from "../Slices/Country/getCountryById";
import { getAllHomeSectionsWithCreatorBySectionNameAction } from "../Slices/ContentManagement/HomeSection/getAllHomeSectionsWithCreatorBySectionName";
import { getAllHomeSectionsBySectionNameBasedOnCreatorAction } from "../Slices/ContentManagement/HomeSection/getAllHomeSectionsBySectionNameBasedOnCreator";
import { addHomeSectionWithApprovalAction } from "../Slices/ContentManagement/HomeSection/addHomeSectionWithApproval";
import { updateHomeSectionForReApprovalAction } from "../Slices/ContentManagement/HomeSection/updateHomeSectionForReApproval";
import { updateHomeSectionAction } from "../Slices/ContentManagement/HomeSection/updateHomeSection";
import { getHomeSectionByIdAction } from "../Slices/ContentManagement/HomeSection/getHomeSectionById";
import { deleteHomeSectionAction } from "../Slices/ContentManagement/HomeSection/deleteHomeSection";
import { addStakeNowSectionWithApprovalAction } from "../Slices/ContentManagement/StakeNowSection/addStakeNowSectionWithApproval";
import { getAllStakeNowSectionsWithCreatorBySectionNameAction } from "../Slices/ContentManagement/StakeNowSection/getAllStakeNowSectionsWithCreatorBySectionName";
import { getAllStakeNowSectionsBySectionNameBasedOnCreatorAction } from "../Slices/ContentManagement/StakeNowSection/getAllStakeNowSectionsBySectionNameBasedOnCreator";
import { updateStakeNowSectionForReApprovalAction } from "../Slices/ContentManagement/StakeNowSection/updateStakeNowSectionForReApproval";
import { addMultipleKYCsAction } from "../Slices/Country/addMultipleKYCs";
import { addReferralSectionAction } from "../Slices/ContentManagement/ReferralsSection/addReferralSection";
import { addReferralSectionWithApprovalAction } from "../Slices/ContentManagement/ReferralsSection/addReferralSectionWithApproval";
import { deleteReferralSectionAction } from "../Slices/ContentManagement/ReferralsSection/deleteReferralSection";
import { getAllReferralSectionsBySectionNameBasedOnCreatorAction } from "../Slices/ContentManagement/ReferralsSection/getAllReferralSectionsBySectionNameBasedOnCreator";
import { getAllReferralSectionsWithCreatorBySectionNameAction } from "../Slices/ContentManagement/ReferralsSection/getAllReferralSectionsWithCreatorBySectionName";
import { getReferralSectionByIdAction } from "../Slices/ContentManagement/ReferralsSection/getReferralSectionById";
import { updateReferralSectionAction } from "../Slices/ContentManagement/ReferralsSection/updateReferralSection";
import { updateReferralSectionForReApprovalAction } from "../Slices/ContentManagement/ReferralsSection/updateReferralSectionForReApproval";
import { addAboutUsSectionAction } from "../Slices/ContentManagement/AboutUsSection/addAboutUsSection";
import { addAboutUsSectionWithApprovalAction } from "../Slices/ContentManagement/AboutUsSection/addAboutUsSectionWithApproval";
import { deleteAboutUsSectionAction } from "../Slices/ContentManagement/AboutUsSection/deleteAboutUsSection";
import { getAllAboutUsSectionsBySectionNameBasedOnCreatorAction } from "../Slices/ContentManagement/AboutUsSection/getAllAboutUsSectionsBySectionNameBasedOnCreator";
import { getAllAboutUsSectionsWithCreatorBySectionNameAction } from "../Slices/ContentManagement/AboutUsSection/getAllAboutUsSectionsWithCreatorBySectionName";
import { getAboutUsSectionByIdAction } from "../Slices/ContentManagement/AboutUsSection/getAboutUsSectionById";
import { updateAboutUsSectionAction } from "../Slices/ContentManagement/AboutUsSection/updateAboutUsSection";
import { updateAboutUsSectionForReApprovalAction } from "../Slices/ContentManagement/AboutUsSection/updateAboutUsSectionForReApproval";
import { addBlogSectionAction } from "../Slices/ContentManagement/BlogSection/addBlogSection";
import { addBlogSectionWithApprovalAction } from "../Slices/ContentManagement/BlogSection/addBlogSectionWithApproval";
import { deleteBlogSectionAction } from "../Slices/ContentManagement/BlogSection/deleteBlogSection";
import { getBlogSectionByIdAction } from "../Slices/ContentManagement/BlogSection/getBlogSectionById";
import { getAllBlogSectionsBySectionNameBasedOnCreatorAction } from "../Slices/ContentManagement/BlogSection/getAllBlogSectionsBySectionNameBasedOnCreator";
import { getAllBlogSectionsWithCreatorBySectionNameAction } from "../Slices/ContentManagement/BlogSection/getAllBlogSectionsWithCreatorBySectionName";
import { updateBlogSectionAction } from "../Slices/ContentManagement/BlogSection/updateBlogSection";
import { updateBlogSectionForReApprovalAction } from "../Slices/ContentManagement/BlogSection/updateBlogSectionForReApproval";
import { addContactUsSectionAction } from "../Slices/ContentManagement/ContactUsSection/addContactUsSection";
import { addContactUsSectionWithApprovalAction } from "../Slices/ContentManagement/ContactUsSection/addContactUsSectionWithApproval";
import { getContactUsSectionByIdAction } from "../Slices/ContentManagement/ContactUsSection/getContactUsSectionById";
import { getAllContactUsSectionsBySectionNameBasedOnCreatorAction } from "../Slices/ContentManagement/ContactUsSection/getAllContactUsSectionsBySectionNameBasedOnCreator";
import { getAllContactUsSectionsWithCreatorBySectionNameAction } from "../Slices/ContentManagement/ContactUsSection/getAllContactUsSectionsWithCreatorBySectionName";
import { updateContactUsSectionAction } from "../Slices/ContentManagement/ContactUsSection/updateContactUsSection";
import { updateContactUsSectionForReApprovalAction } from "../Slices/ContentManagement/ContactUsSection/updateContactUsSectionForReApproval";
import { deleteContactUsSectionAction } from "../Slices/ContentManagement/ContactUsSection/deleteContactUsSection";
import { getAllPendingCustomersWithCreatorAction } from "../Slices/Approvals/RegistrationApprovals/getAllPendingCustomersWithCreator";
import { getAllApprovedCustomersWithCreatorAndApproverAction } from "../Slices/Approvals/RegistrationApprovals/getAllApprovedCustomersWithCreatorAndApprover";
import { rejectCustomerAction } from "../Slices/Approvals/RegistrationApprovals/rejectCustomer";
import { getAllRejectedCustomersWithCreatorAndRejectorAction } from "../Slices/Approvals/RegistrationApprovals/getAllRejectedCustomersWithCreatorAndRejector";
import { getAllReapprovalCustomersWithCreatorAndRejectorAction } from "../Slices/Approvals/RegistrationApprovals/getAllReapprovalCustomersWithCreatorAndRejector";
import { getAllHomeSectionsBySectionNameAction } from "../Slices/ContentManagement/HomeSection/getAllHomeSectionsBySectionName";
import { rejectHomeSectionAction } from "../Slices/ContentManagement/HomeSection/rejectHomeSection";
import { approveHomeSectionAction } from "../Slices/ContentManagement/HomeSection/approveHomeSection";
import { approveStakeNowSectionAction } from "../Slices/ContentManagement/StakeNowSection/approveStakeNowSection";
import { rejectStakeNowSectionAction } from "../Slices/ContentManagement/StakeNowSection/rejectStakeNowSection";
import { approveReferralSectionAction } from "../Slices/ContentManagement/ReferralsSection/approveReferralSection";
import { rejectReferralSectionAction } from "../Slices/ContentManagement/ReferralsSection/rejectStakeNowSection";
import { approveAboutUsSectionAction } from "../Slices/ContentManagement/AboutUsSection/approveAboutUsSection";
import { rejectAboutUsSectionAction } from "../Slices/ContentManagement/AboutUsSection/rejectAboutUsSection";
import { approveBlogSectionAction } from "../Slices/ContentManagement/BlogSection/approveBlogSection";
import { rejectBlogSectionAction } from "../Slices/ContentManagement/BlogSection/rejectBlogSection";
import { rejectContactUsSectionAction } from "../Slices/ContentManagement/ContactUsSection/rejectContactUsSection";
import { approveContactUsSectionAction } from "../Slices/ContentManagement/ContactUsSection/approveContactUsSection";

import { getAllPendingPlansWithCreatorAction } from "../Slices/Management/getAllPendingPlansWithCreator";
import { getAllApprovedPlansWithCreatorAndApproverAction } from "../Slices/Management/getAllApprovedPlansWithCreatorAndApprover";
import { getAllRejectedPlansWithCreatorAndRejectorAction } from "../Slices/Management/getAllRejectedPlansWithCreatorAndRejector";
import { getAllReapprovalPlansWithCreatorAndRejectorAction } from "../Slices/Management/getAllReapprovalPlansWithCreatorAndRejector";
import { approvePlanAction } from "../Slices/Management/approvePlan";
import { rejectPlanAction } from "../Slices/Management/rejectPlan";
import { getAllPendingPurchasesWithCreatorAction } from "../Slices/Management/getAllPendingPurchasesWithCreator";
import { getAllApprovedPurchasesWithCreatorAndApproverAction } from "../Slices/Management/getAllApprovedPurchasesWithCreatorAndApprover";
import { approvePurchaseAction } from "../Slices/Management/approvePurchase";
import { getAllActiveTiersAction } from "../Slices/Tiers/getAllActiveTiers";
import { getAllCountriesWithDetailsAction } from "../Slices/Country/getAllCountriesWithDetails";
import { getCountryWithDetailsByIdAction } from "../Slices/Country/getCountryWithDetailsById";
import { addPlanWithApprovalAction } from "../Slices/Schemes/addPlanWithApproval";
import { updatePlanForReApprovalAction } from "../Slices/Schemes/updatePlanForReApproval";
import { getAllPlansWithCreatorAction } from "../Slices/Schemes/getAllPlansWithCreator";
import { getAllPlansBasedOnCreatorAction } from "../Slices/Schemes/getAllPlansBasedOnCreator";
import { getManagementDashboardDataAction } from "../Slices/Dashboard/getManagementDashboardData";




const actions = {
  // ...RptLoadNoDropDownAction,
  // ...RptStatusDropDownAction,

  // ...CategoryTableGetAllAction,
  // ...GetAllOrdersByCustomerAction,
  ...getAllHomeSectionsAction,
  ...getAllstakeNowSectionsAction,
  ...getAllReferralsSectionsAction,
  ...getAllBlogSectionsAction,
  ...getAllContactUsSectionsAction,
  ...getAllAboutUsSectionsAction,
  ...postContactUsFormAction,
  ...customerRegisterAction,
  ...customerLoginAction,
  ...PurchaseSchemesAction,
  ...ImageUploadPostAction,
  ...getKYCByCountryAction,
  ...getCustomerGoldBalanceDashboardAction,
  ...getPurchasesByCustomerIdAction,
  ...getCustomerRewardsListAction,
  ...getReferralRewardDashboardAction,
  ...getCartItemCountAction,
  ...EmailSendOtpAction,
  ...EmailVerifyOtpAction,
  ...addMultiPurchaseAction,
  ...resetPasswordForCustomerAction,
  ...getPlanByIdAction,
  ...managementRegisterForCustomerAction,
  ...loginOperatorAction,
  ...getCustomersByCreatorAction,
  ...getAllActivePlansAction,
  ...getOperatorDashboardMetricsAction,
  ...getCartItemsAction,
  ...decrementQuantityAction,
  ...incrementQuantityAction,
  ...clearCartAction,
  ...uploadPdfAndImageAction,
  ...getPurchasesByCreatorAction,
  ...getCashPurchasesByCreatorAction,
  ...getAllCustomersStatusAction,
  ...getCustomerByIdAction,
  ...approveCustomerAction,
  ...checkCustomerExistForEmailRegisterAction,
  ...checkCustomerExistPhoneForRegisterAction,
  ...getAllUserWithRoleAction,
  ...multiUserCreationAction,
  ...getNetBankingPurchasesByCreatorAction,
  ...addPlanPostAction,
  ...getAllPlansGetAction,
  ...getAllFinanceConsultantListForAuthUserAction,
  ...getAllCustomerRewardsListForAuthUserAction,
  ...getAllPurchasesListForAuthUserAction,
  ...getAllTiersAction,
  ...createTierAction,
  ...getAllRolesWithModulesAction,
  ...createRoleWithPermissionsAction,
  ...getAllRolesAction,
  ...getPurchaseByIdAction,
  ...updatePlanPutAction,
  ...getPermissionsForAuthUserAction,
  ...updateAllPermissionsForAuthUserAction,
  ...getReferrerCustomerRewardsByCustomerIdAction,
  ...activateLastTierAction,
  ...inactivateLastTierAction,
  ...getAuthUserByIdAction,
  ...updateAuthUserAction,
  ...softDeleteAuthUserAction,
  ...updateTierAction,
  ...getTierByIdAction,
  ...deletePlanAction,
  ...addHomeSectionPostAction,
  ...addStakeNowSectionPostAction,
  ...getStakeNowSectionByIdAction,
  ...updateStakeNowSectionAction,
  ...getAllCountryNamesAction,
  ...getAllStatesByCountryAction,
  ...getAllCitiesByStateAction,
  ...deleteStakeNowSectionAction,
  ...AddCountryPostAction,
  ...AddStatePostAction,
  ...AddCityPostAction,
  ...getCountryByIdAction,
  ...getAllHomeSectionsWithCreatorBySectionNameAction,
  ...getAllHomeSectionsBySectionNameBasedOnCreatorAction,
  ...addHomeSectionWithApprovalAction,
  ...updateHomeSectionForReApprovalAction,
  ...updateHomeSectionAction,
  ...getHomeSectionByIdAction,
  ...deleteHomeSectionAction,
  ...addStakeNowSectionWithApprovalAction,
  ...getAllStakeNowSectionsWithCreatorBySectionNameAction,
  ...getAllStakeNowSectionsBySectionNameBasedOnCreatorAction,
  ...updateStakeNowSectionForReApprovalAction,
  ...addMultipleKYCsAction,
  ...addReferralSectionAction,
  ...addReferralSectionWithApprovalAction,
  ...deleteReferralSectionAction,
  ...getAllReferralSectionsBySectionNameBasedOnCreatorAction,
  ...getAllReferralSectionsWithCreatorBySectionNameAction,
  ...getReferralSectionByIdAction,
  ...updateReferralSectionAction,
  ...updateReferralSectionForReApprovalAction,
  ...addAboutUsSectionAction,
  ...addAboutUsSectionWithApprovalAction,
  ...deleteAboutUsSectionAction,
  ...getAllAboutUsSectionsBySectionNameBasedOnCreatorAction,
  ...getAllAboutUsSectionsWithCreatorBySectionNameAction,
  ...getAboutUsSectionByIdAction,
  ...updateAboutUsSectionAction,
  ...updateAboutUsSectionForReApprovalAction,
  ...addBlogSectionAction,
  ...addBlogSectionWithApprovalAction,
  ...deleteBlogSectionAction,
  ...getBlogSectionByIdAction,
  ...getAllBlogSectionsBySectionNameBasedOnCreatorAction,
  ...getAllBlogSectionsWithCreatorBySectionNameAction,
  ...updateBlogSectionAction,
  ...updateBlogSectionForReApprovalAction,
  ...addContactUsSectionAction,
  ...addContactUsSectionWithApprovalAction,
  ...deleteContactUsSectionAction,
  ...getContactUsSectionByIdAction,
  ...getAllContactUsSectionsBySectionNameBasedOnCreatorAction,
  ...getAllContactUsSectionsWithCreatorBySectionNameAction,
  ...updateContactUsSectionAction,
  ...updateContactUsSectionForReApprovalAction,
  ...getAllPendingCustomersWithCreatorAction,
  ...getAllApprovedCustomersWithCreatorAndApproverAction,
  ...rejectCustomerAction,
  ...getAllRejectedCustomersWithCreatorAndRejectorAction,
  ...getAllReapprovalCustomersWithCreatorAndRejectorAction,
  ...getAllHomeSectionsBySectionNameAction,
  ...rejectHomeSectionAction,
  ...approveHomeSectionAction,
  ...approveStakeNowSectionAction,
  ...rejectStakeNowSectionAction,
  ...approveReferralSectionAction,
  ...rejectReferralSectionAction,
  ...approveAboutUsSectionAction,
  ...rejectAboutUsSectionAction,
  ...approveBlogSectionAction,
  ...rejectBlogSectionAction,
  ...rejectContactUsSectionAction,
  ...approveContactUsSectionAction,

  ...getAllPendingPlansWithCreatorAction,
  ...getAllApprovedPlansWithCreatorAndApproverAction,
  ...getAllRejectedPlansWithCreatorAndRejectorAction,
  ...getAllReapprovalPlansWithCreatorAndRejectorAction,
  ...approvePlanAction,
  ...rejectPlanAction,
  ...getAllPendingPurchasesWithCreatorAction,
  ...getAllApprovedPurchasesWithCreatorAndApproverAction,
  ...approvePurchaseAction,
  ...getAllActiveTiersAction,
  ...getAllCountriesWithDetailsAction,
  ...getCountryWithDetailsByIdAction,
  ...addPlanWithApprovalAction,
  ...updatePlanForReApprovalAction,
  ...getAllPlansWithCreatorAction,
  ...getAllPlansBasedOnCreatorAction,
  ...getManagementDashboardDataAction,






};

export default actions;
